import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onethreeseaterurbaniaonrentinpune() {



    const cardData =
    {
        keyword: '13 Seater Urbania On Rent in Pune',
        heading: 'Urbania on rent in pune: 13 Seater Urbania On Rent in Pune',
        headingDescription: 'Urbania On Rent in Pune offers comfortable and reliable 13 Seater Urbania on Rent in Pune for corporate travel, family trips, weddings, tours, and group transportation across the city. Our well-maintained Force Urbania 13-seater vehicles are spacious, air-conditioned, and designed for smooth journeys, making them ideal for airport transfers, corporate events, sightseeing, and outstation travel from Pune. With experienced chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from prime locations including Hinjewadi, Baner, Wakad, Kothrud, Hadapsar, Viman Nagar, Pimpri Chinchwad, and Pune Airport, we ensure a safe and hassle-free travel experience.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


        "topPlaces": [
            {
                "title": "Shaniwar Wada",
                "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical landmark and a symbol of Maratha power. Once the administrative seat of Bajirao I, the fort complex featured grand halls, fountains, and courtyards. Although a major fire destroyed much of the structure, the massive stone walls, gates like the Delhi Darwaza, and remaining ruins still reflect its former grandeur. The evening light-and-sound show vividly narrates Maratha history, making it a must-visit heritage attraction."
            },
            {
                "title": "Aga Khan Palace",
                "description": "Aga Khan Palace is a significant monument linked to India’s freedom struggle. Built in 1892, it served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. Today, it houses a museum displaying photographs, letters, and personal belongings of Gandhi. Surrounded by lush gardens and Italian-style arches, the palace offers a peaceful yet historically powerful experience."
            },
            {
                "title": "Sinhagad Fort",
                "description": "Sinhagad Fort stands atop a rugged hill in the Sahyadri range and is renowned for the heroic sacrifice of Tanaji Malusare in 1670. The fort offers breathtaking panoramic views of Pune and surrounding valleys. Visitors can trek or drive to explore ancient ramparts, memorials, and gates. Local food stalls serving traditional pithla-bhakri add to the authentic experience, making it a favorite spot for history lovers and adventure seekers."
            },
            {
                "title": "Dagdusheth Halwai Ganpati Temple",
                "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The beautifully adorned idol, decorated with gold ornaments, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the heart of grand celebrations with processions and cultural events. The temple trust is also known for its social and charitable initiatives, making it both a spiritual and cultural landmark."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. Despite being located in a busy area, the temple offers a calm and meditative atmosphere. The monolithic pillars, circular Nandi mandap, and ancient carvings showcase early Indian craftsmanship. It is one of Pune’s lesser-known yet spiritually rich heritage sites."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar to preserve Indian art and culture. Exhibits include musical instruments, sculptures, lamps, utensils, and traditional household items. The recreated Mastani Mahal is a major highlight. The museum offers a deep insight into India’s cultural diversity and traditional craftsmanship."
            },
            {
                "title": "Parvati Hill and Temple",
                "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic city views after climbing 103 stone steps. The hilltop temple complex dates back to the Peshwa era and is dedicated to Lord Shiva and Goddess Parvati. Smaller temples and a museum enrich the visit. Sunrise and sunset views from the hill are especially popular among locals and tourists."
            },
            {
                "title": "Osho Ashram",
                "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-famous center for meditation and mindfulness. Spread across landscaped gardens, it offers meditation programs, wellness therapies, and spiritual retreats. Visitors from across the globe come here seeking inner peace, relaxation, and personal transformation, making it an international spiritual destination."
            },
            {
                "title": "Pu La Deshpande Garden",
                "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. It features flowing streams, arched bridges, manicured lawns, and seasonal flowers. Ideal for morning walks, family outings, and photography, the garden blends Japanese aesthetics with Indian natural beauty, offering a serene green escape."
            },
            {
                "title": "Khadakwasla Dam",
                "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. The vast reservoir, cool breeze, and surrounding hills create a refreshing atmosphere, especially during monsoon and evenings. Street vendors selling corn and tea add local charm. It also serves as a gateway to Sinhagad Fort, making it a scenic leisure destination."
            }
        ],


"services": [
    {
      "name": "13 Seater Urbania On Rent in Pune",
      "description": "13 Seater Urbania On Rent in Pune offers a spacious and comfortable travel solution for medium-sized groups, families, and corporate teams. With modern interiors, pushback seating, and ample luggage space, it ensures a smooth and relaxing journey. Ideal for local travel, outstation trips, and events, this service provides professional chauffeurs and well-maintained vehicles for a hassle-free experience."
    },
    {
      "name": "Urbania 13 Seater Rent Pune",
      "description": "Urbania 13 Seater Rent Pune provides flexible rental options for daily, weekend, and long-distance travel needs. Perfect for family outings, business trips, and group tours, it ensures clean vehicles, punctual service, and experienced drivers. Customers can enjoy reliable and comfortable travel across Pune and nearby destinations."
    },
    {
      "name": "13 Seater Urbania Hire Pune",
      "description": "13 Seater Urbania Hire Pune delivers dependable and comfortable transportation for group travel, events, and tours. With AC comfort, spacious seating, and trained chauffeurs, it ensures safe and enjoyable journeys. Suitable for both personal and corporate use, this service offers convenience and reliability."
    },
    {
      "name": "Force Urbania 13 Seater Rent Pune",
      "description": "Force Urbania 13 Seater Rent Pune offers modern and premium vehicles designed for group travel with comfort and safety. Equipped with advanced features, spacious interiors, and smooth driving experience, it is ideal for family trips, business travel, and outstation journeys with professional driver support."
    },
    {
      "name": "13 Seater Urbania Rental Pune",
      "description": "13 Seater Urbania Rental Pune provides customized rental packages for short-term, full-day, and multi-day travel. Whether for local sightseeing or long-distance tours, the service ensures well-maintained vehicles, professional chauffeurs, and consistent service quality for stress-free travel."
    },
    {
      "name": "13 Seater Urbania Booking Pune",
      "description": "13 Seater Urbania Booking Pune offers quick and convenient booking options for group travel in Pune. With transparent pricing, responsive customer support, and reliable vehicles, customers can easily plan their trips for family outings, corporate needs, or special events."
    },
    {
      "name": "Pune 13 Seater Urbania on Rent",
      "description": "Pune 13 Seater Urbania on Rent provides comfortable and efficient transportation for small to medium groups. With spacious seating, luggage capacity, and smooth ride quality, it is perfect for local travel, outstation trips, and event transportation across Pune."
    },
    {
      "name": "13 Seater Luxury Urbania Pune",
      "description": "13 Seater Luxury Urbania Pune offers a premium travel experience with plush interiors, pushback seats, and superior comfort. Ideal for VIP travel, corporate executives, and luxury tours, this service combines style, comfort, and professional chauffeur-driven travel."
    },
    {
      "name": "Urbania Van 13 Seater Pune",
      "description": "Urbania Van 13 Seater Pune is designed for efficient group travel with modern features and spacious interiors. Suitable for city rides, airport transfers, and family outings, it ensures a smooth journey with comfortable seating and sufficient luggage space."
    },
    {
      "name": "13 Seater Urbania Price Pune",
      "description": "13 Seater Urbania Price Pune offers competitive and transparent pricing for all travel requirements. Whether for local trips or long-distance journeys, customers receive clear fare details with no hidden charges, making it an affordable and reliable option in Pune."
    },
    {
      "name": "13 Seater Urbania Hire Charges Pune",
      "description": "13 Seater Urbania Hire Charges Pune provides flexible and budget-friendly pricing plans tailored to different travel needs. With hourly, daily, and outstation packages, customers can choose cost-effective options without compromising on comfort and safety."
    },
    {
      "name": "13 Seater Urbania for Outstation Pune",
      "description": "13 Seater Urbania for Outstation Pune is ideal for long-distance travel, weekend getaways, and tours. With comfortable seating, AC facilities, and experienced highway drivers, it ensures safe and smooth journeys to destinations like Lonavala, Mahabaleshwar, Shirdi, and Goa."
    },
    {
      "name": "13 Seater Urbania for Family Trip Pune",
      "description": "13 Seater Urbania for Family Trip Pune is perfect for family vacations, religious trips, and leisure travel. With spacious seating, luggage capacity, and courteous chauffeurs, it ensures a comfortable and enjoyable journey for all family members."
    },
    {
      "name": "13 Seater Urbania for Corporate Travel Pune",
      "description": "13 Seater Urbania for Corporate Travel Pune offers professional and reliable transportation for office trips, meetings, conferences, and events. With punctual service, trained drivers, and clean vehicles, it ensures smooth and efficient corporate group travel."
    },
    {
      "name": "Urbania 13 Seater On Rent Near Me Pune",
      "description": "Urbania 13 Seater On Rent Near Me Pune provides easy access to nearby Urbania rental services with quick booking options. Whether for urgent travel, planned trips, or group outings, customers can rely on well-maintained vehicles and professional chauffeurs for a hassle-free experience."
    }
  ],
  "tableData": [
    ["13 Seater Urbania On Rent in Pune", "Urbania 13 Seater Rent Pune"],
    ["13 Seater Urbania Hire Pune", "Force Urbania 13 Seater Rent Pune"],
    ["13 Seater Urbania Rental Pune", "13 Seater Urbania Booking Pune"],
    ["Pune 13 Seater Urbania on Rent", "13 Seater Luxury Urbania Pune"],
    ["Urbania Van 13 Seater Pune", "13 Seater Urbania Price Pune"],
    ["13 Seater Urbania Hire Charges Pune", "13 Seater Urbania for Outstation Pune"],
    ["13 Seater Urbania for Family Trip Pune", "13 Seater Urbania for Corporate Travel Pune"],
    ["Urbania 13 Seater On Rent Near Me Pune", ""]
  ],








"whychoose": [
    {
        "WhyChooseheading": "Best 13 Seater Urbania on Rent in Pune",
        "WhyChoosedescription": "13 Seater Urbania on Rent in Pune is ideal for medium-sized groups, offering comfort and convenience for family trips, corporate outings, weddings, and outstation travel."
    },
    {
        "WhyChooseheading": "Luxury and Spacious Force Urbania Vehicles",
        "WhyChoosedescription": "13 Seater Urbania on Rent in Pune provides premium Force Urbania vehicles with modern interiors, ample legroom, and air-conditioning for a smooth and enjoyable journey."
    },
    {
        "WhyChooseheading": "Professional and Skilled Drivers",
        "WhyChoosedescription": "13 Seater Urbania on Rent in Pune comes with experienced drivers who are familiar with local routes and highways, ensuring safe and timely travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose 13 Seater Urbania on Rent in Pune for competitive pricing with no hidden charges, making group travel budget-friendly and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "13 Seater Urbania on Rent in Pune offers round-the-clock support for bookings, inquiries, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "13 Seater Urbania on Rent in Pune is available for hourly rentals, full-day bookings, corporate trips, wedding transportation, and customized outstation packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles for 13 Seater Urbania on Rent in Pune are regularly serviced and sanitized to ensure a safe, clean, and comfortable journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "13 Seater Urbania on Rent in Pune guarantees on-time pickups and dependable service, ensuring smooth and stress-free group travel."
    }
]
}

const faqData = [
    {
        question: 'Is 13 Seater Urbania on Rent in Pune available for local and outstation travel?',
        answer: 'Yes, 13 Seater Urbania on Rent in Pune is available for both local city travel and outstation journeys, offering a comfortable and premium travel experience.',
    },
    {
        question: 'How can I book 13 Seater Urbania on Rent in Pune?',
        answer: 'You can easily book 13 Seater Urbania on Rent in Pune via phone, WhatsApp, or online booking for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose 13 Seater Urbania on Rent in Pune for group travel?',
        answer: '13 Seater Urbania on Rent in Pune provides spacious seating, ample luggage space, luxury interiors, and a smooth ride, making it perfect for family, group, and corporate travel.',
    },
    {
        question: 'Is 13 Seater Urbania on Rent in Pune suitable for corporate and event travel?',
        answer: 'Yes, 13 Seater Urbania on Rent in Pune is ideal for corporate trips, airport transfers, weddings, events, and business meetings.',
    },
    {
        question: 'Are drivers experienced with 13 Seater Urbania on Rent in Pune?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles to ensure safety and comfort.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with 13 Seater Urbania on Rent in Pune?',
        answer: 'Absolutely. 13 Seater Urbania on Rent in Pune allows flexible pickup and drop-off locations across Pune and nearby areas.',
    },
    {
        question: 'Is 13 Seater Urbania on Rent in Pune available 24x7?',
        answer: 'Yes, 13 Seater Urbania on Rent in Pune operates 24x7 to meet your travel needs anytime.',
    },
    {
        question: 'Are hygiene and safety standards maintained for 13 Seater Urbania on Rent in Pune?',
        answer: 'Yes, all vehicles are regularly sanitized and maintained, and strict safety protocols are followed for every trip.',
    },
    {
        question: 'What payment options are available for 13 Seater Urbania on Rent in Pune?',
        answer: '13 Seater Urbania on Rent in Pune accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout your journey to ensure a smooth and stress-free experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ajit Kulkarni',
        feedback: 'We booked 13 Seater Urbania on Rent in Pune for a family outing. The vehicle was spacious, clean, and very comfortable. Great experience!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Rutuja Deshmukh',
        feedback: '13 Seater Urbania on Rent in Pune provided excellent service for our corporate trip. Professional driver, smooth ride, and comfortable interiors. Highly recommended!',
        rating: 5,
    },
];









































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "13 Seater Urbania On Rent in Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/13-seater-urbania-on-rent-pune.jpg",
  "description": "13 Seater Urbania On Rent in Pune offers premium Force Urbania rental services for corporate travel, family trips, weddings, airport transfers, group travel, and outstation tours. Spacious 13 seater AC luxury Urbania buses with professional chauffeur-driven service are available at affordable prices.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "1450",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/13-seater-urbania-on-rent-pune"
  }
};







    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | 13 Seater Urbania On Rent in Pune | Luxury AC Urbania Bus Hire 
  </title>

  <meta
    name="description"
    content="Book 13 Seater Urbania on rent in Pune for corporate travel, family trips, weddings, airport transfers, group tours, and outstation journeys. Luxury AC 13 seater Urbania bus hire with chauffeur-driven service at affordable rates."
  />

  <meta
    name="keywords"
    content="13 seater urbania on rent in pune, urbania 13 seater rent pune, 13 seater urbania hire pune, force urbania 13 seater rent pune, 13 seater urbania rental pune, 13 seater urbania booking pune, pune 13 seater urbania on rent, 13 seater luxury urbania pune, urbania van 13 seater pune, 13 seater urbania price pune, 13 seater urbania hire charges pune, 13 seater urbania for outstation pune, 13 seater urbania for family trip pune, 13 seater urbania for corporate travel pune, urbania 13 seater on rent near me pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/117.jpeg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onethreeseaterurbaniaonrentinpune;